import { useState, useRef, useEffect } from 'react'
import ImageModalContent from '../common/ImageModalContent'
import useModal from '../../common/hooks/useModal'
import PrivateFile from '../common/PrivateFile'

export default function AttachmentsSlider({
    slides = [],
    contentTop,
    contentTopRight,
    contentBottomRight,
    ratio = 1,
    hasZoom,
}) {
    const [currentSlideIndex, setCurrentSlide] = useState(0)
    const { setModal } = useModal()
    const length = slides.length
    const [startX, setStartX] = useState(0)
    const [endX, setEndX] = useState(0)

    function handleNextSlide() {
        setCurrentSlide(
            currentSlideIndex === length - 1 ? 0 : currentSlideIndex + 1,
        )
    }

    function handlePrevSlide() {
        setCurrentSlide(
            currentSlideIndex === 0 ? length - 1 : currentSlideIndex - 1,
        )
    }

    function handleMainClick() {
        if (!hasZoom) return
        setModal(<ImageModalContent src={slides[currentSlideIndex].imageUrl} />)
    }

    function handleTouchStart(e) {
        setStartX(e.touches[0].clientX)
    }

    function handleTouchMove(e) {
        setEndX(e.touches[0].clientX)
    }

    function handleTouchEnd() {
        if (startX - endX > 50) {
            handleNextSlide()
        } else if (endX - startX > 50) {
            handlePrevSlide()
        }
    }

    if (!slides.length) {
        return null
    }

    const currentSlide = slides[currentSlideIndex]

    const imageStyle = {
        '--padding-bottom': `${ratio * 100}%`,
    }

    const showPrevButton = length > 1 && currentSlideIndex !== 0
    const showNextButton = length > 1 && currentSlideIndex !== length - 1

    return (
        <div
            className={`attachments-slider${hasZoom ? ' has-zoom' : ''}`}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <div className="inner-slider" style={imageStyle}>
                <div className="slider-content">
                    <div>{contentTop}</div>
                    <div>{contentTopRight}</div>
                    <div></div>
                    <div>{contentBottomRight}</div>
                </div>

                <div className="slider-image-container">
                    {currentSlide.imageUrl ? (
                        <img
                            key={currentSlide.imageUrl}
                            loading="lazy"
                            onClick={handleMainClick}
                            src={currentSlide.imageUrl}
                            alt="slider"
                            className="slider-image"
                        />
                    ) : null}
                    {currentSlide.videoUrl ? (
                        <video
                            key={currentSlide.videoUrl}
                            loading="lazy"
                            src={currentSlide.videoUrl}
                            alt="slider"
                            className="slider-image"
                            controls
                        />
                    ) : null}
                    {currentSlide.pdfUrl ? (
                        <iframe
                            key={currentSlide.pdfUrl}
                            loading="lazy"
                            src={currentSlide.pdfUrl}
                            alt="slider"
                            className="slider-image"
                        />
                    ) : null}
                    {currentSlide.driveFileId ? (
                        <PrivateFile
                            key={currentSlide.driveFileId}
                            driveFileId={currentSlide.driveFileId}
                            openFullOnClick
                        />
                    ) : null}
                    {!currentSlide.imageUrl &&
                    !currentSlide.videoUrl &&
                    !currentSlide.driveFileId ? (
                        <div className="slider-image-placeholder"></div>
                    ) : null}
                </div>

                {showPrevButton && (
                    <button
                        onClick={handlePrevSlide}
                        className="slider-prev"
                        title="Previous"
                    >
                        <img
                            alt="previous"
                            src="/img/icons/chevron-left-white.svg"
                        ></img>
                    </button>
                )}

                {showNextButton && (
                    <button
                        onClick={handleNextSlide}
                        className="slider-next"
                        title="Next"
                    >
                        <img
                            style={{ transform: 'rotate(180deg)' }}
                            alt="next"
                            src="/img/icons/chevron-left-white.svg"
                        ></img>
                    </button>
                )}
            </div>

            <ul>
                {slides.map((slide, index) => (
                    <li
                        role="button"
                        onClick={() => setCurrentSlide(index)}
                        className={`${currentSlide === slide ? 'active' : ''}`}
                        key={index}
                    >
                        {slide.imageUrl ? (
                            <img
                                src={slide.imageUrl}
                                loading="lazy"
                                alt={`Thumbnail ${index + 1}`}
                                className="thumbnail"
                            />
                        ) : null}
                        {slide.driveFileId ? (
                            <PrivateFile driveFileId={slide.driveFileId} />
                        ) : null}
                        {!slide.imageUrl && !slide.driveFileId && (
                            <span>
                                {slide?.videoUrl?.slice(0, 30) ||
                                    slide?.pdfUrl?.slice(0, 30) ||
                                    slide?.fileUrl?.slice(0, 30) ||
                                    slide?.url?.slice(0, 30)}
                                ...
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    )
}
